import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import Flatpickr from "react-flatpickr";

import PropTypes from "prop-types";
import { withRouter, Link, useHistory } from "react-router-dom";
import { withTranslation } from "react-i18next";

const Section = (props) => {
  const [idx, setIdx] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"));

      // console.log( "obj: ", obj );

      setEmail(obj.data.email);
      setFirstName(obj.data.first_name);
      setLastName(obj.data.last_name);
      setIdx(obj.data.id || "1");
    }
  }, []);

  const sidebar = () => {
    const element = document.getElementById("layout-rightside-coll");
    element.classList.toggle("d-none");
  };

  return (
    <React.Fragment>
      <Row className="mb-3 pb-1">
        <Col xs={12}>
          <div className="d-flex align-items-lg-center flex-lg-row flex-column">
            <div className="flex-grow-1">
              <h4 className="fs-16 mb-1">
                {props.t("Welcome")} {firstName + " " + lastName}!
              </h4>
              <p className="text-muted mb-0">
                {props.t("Here's what's happening today.")}
              </p>
            </div>
            <div className="mt-3 mt-lg-0">
              <form action="#">
                <Row className="g-3 mb-0 align-items-center">
                  <div className="col-sm-auto">
                    <div className="input-group">
                      <Flatpickr
                        className="form-control border-0 dash-filter-picker shadow"
                        options={{
                          mode: "range",
                          dateFormat: "d M, Y",
                          defaultDate: [
                            props.periode?.debut,
                            props.periode?.fin,
                          ].filter(Boolean),
                        }}
                        onChange={(dates) => {
                          // Flatpickr émet dès le premier clic : on attend que
                          // les deux bornes soient posées.
                          if (dates.length === 2 && props.onPeriodeChange) {
                            props.onPeriodeChange({
                              debut: dates[0],
                              fin: dates[1],
                            });
                          }
                        }}
                      />
                      <div className="input-group-text bg-primary border-primary text-white">
                        <i className="ri-calendar-2-line"></i>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-auto">
                                        <button type="button" className="btn btn-soft-success"><i className="ri-add-circle-line align-middle me-1"></i> Add Product</button>
                                    </div> */}
                  <div className="col-auto">
                    <button
                      type="button"
                      className="btn btn-soft-info btn-icon waves-effect waves-light layout-rightside-btn"
                      onClick={() => sidebar()}
                    >
                      <i className="ri-pulse-line"></i>
                    </button>
                  </div>
                </Row>
              </form>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

Section.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Section));
